export class Me {
  title: string;
  permissions: any[];

  constructor({ title = "FM", permissions = [] }) {
    this.title = title;
    this.permissions = permissions || [];
  }

  isAuthRes(resCode: string) {
    return !!this.permissions.find((x: any) => x.resId === resCode);
  }
}
